import { render, staticRenderFns } from "./ImportarModalNuevo.vue?vue&type=template&id=2c1041c4&scoped=true&"
import script from "./ImportarModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ImportarModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ImportarModalNuevo.vue?vue&type=style&index=0&id=2c1041c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1041c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2c1041c4', component.options)
    } else {
      api.reload('2c1041c4', component.options)
    }
    module.hot.accept("./ImportarModalNuevo.vue?vue&type=template&id=2c1041c4&scoped=true&", function () {
      api.rerender('2c1041c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/ImportarModalNuevo.vue"
export default component.exports